<script>
import { getUnixTime } from 'date-fns';
import { findSnoozeTime } from 'dashboard/helper/snoozeHelpers';
import { emitter } from 'shared/helpers/mitt';
import wootConstants from 'dashboard/constants/globals';
import {
  CMD_BULK_ACTION_SNOOZE_CONVERSATION,
  CMD_BULK_ACTION_REOPEN_CONVERSATION,
  CMD_BULK_ACTION_RESOLVE_CONVERSATION,
} from 'dashboard/helper/commandbar/events';

import CustomSnoozeModal from 'dashboard/components/CustomSnoozeModal.vue';
export default {
  components: {
    CustomSnoozeModal,
  },
  props: {
    conversations: {
      type: Array,
      default: () => [],
    },
    allConversationsSelected: {
      type: Boolean,
      default: false,
    },
    selectedInboxes: {
      type: Array,
      default: () => [],
    },
    showOpenAction: {
      type: Boolean,
      default: false,
    },
    showResolvedAction: {
      type: Boolean,
      default: false,
    },
    showSnoozedAction: {
      type: Boolean,
      default: false,
    },
    isModalOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'selectAllConversations',
    'assignAgent',
    'updateConversations',
    'assignLabels',
    'assignTeam',
    'resolveConversations',
    'showMoreActions',
    'exitSelectionMode',
  ],
  data() {
    return {
      showCustomTimeSnoozeModal: false,
    };
  },
  mounted() {
    emitter.on(
      CMD_BULK_ACTION_SNOOZE_CONVERSATION,
      this.onCmdSnoozeConversation
    );
    emitter.on(
      CMD_BULK_ACTION_REOPEN_CONVERSATION,
      this.onCmdReopenConversation
    );
    emitter.on(
      CMD_BULK_ACTION_RESOLVE_CONVERSATION,
      this.onCmdResolveConversation
    );
  },
  unmounted() {
    emitter.off(
      CMD_BULK_ACTION_SNOOZE_CONVERSATION,
      this.onCmdSnoozeConversation
    );
    emitter.off(
      CMD_BULK_ACTION_REOPEN_CONVERSATION,
      this.onCmdReopenConversation
    );
    emitter.off(
      CMD_BULK_ACTION_RESOLVE_CONVERSATION,
      this.onCmdResolveConversation
    );
  },
  methods: {
    onCmdSnoozeConversation(snoozeType) {
      if (snoozeType === wootConstants.SNOOZE_OPTIONS.UNTIL_CUSTOM_TIME) {
        this.showCustomTimeSnoozeModal = true;
      } else {
        this.updateConversations('snoozed', findSnoozeTime(snoozeType) || null);
      }
    },
    onCmdReopenConversation() {
      this.updateConversations('open', null);
    },
    onCmdResolveConversation() {
      this.updateConversations('resolved', null);
    },
    customSnoozeTime(customSnoozedTime) {
      this.showCustomTimeSnoozeModal = false;
      if (customSnoozedTime) {
        this.updateConversations('snoozed', getUnixTime(customSnoozedTime));
      }
    },
    hideCustomSnoozeModal() {
      this.showCustomTimeSnoozeModal = false;
    },
    selectAll(e) {
      this.$emit('selectAllConversations', e.target.checked);
    },
    submit(agent) {
      this.$emit('assignAgent', agent);
    },
    updateConversations(status, snoozedUntil) {
      this.$emit('updateConversations', status, snoozedUntil);
    },
    assignLabels(labels) {
      this.$emit('assignLabels', labels);
    },
    assignTeam(team) {
      this.$emit('assignTeam', team);
    },
    resolveConversations() {
      this.$emit('resolveConversations');
    },
  },
};
</script>

<template>
  <div class="px-3 pt-2 relative">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-2">
        <!-- Exit selection mode button -->
        <button
          class="flex items-center flex-row rounded-full border p-1.5 select-none cursor-pointer text-sm border-n-slate-4 dark:border-n-slate-4 text-n-slate-11 hover:text-n-slate-12"
          @click="$emit('exitSelectionMode')"
        >
          <i class="i-lucide-x text-sm" />
        </button>

        <!-- Select all checkbox -->
        <label class="flex items-center flex-row rounded-full border p-1.5 select-none cursor-pointer text-sm transition-all duration-150"
          :class="allConversationsSelected ? 'border-n-brand bg-n-brand/10 text-n-blue-text' : 'border-n-slate-4 text-n-slate-11 hover:text-n-slate-12'"
        >
          <input
            type="checkbox"
            class="hidden"
            :checked="allConversationsSelected"
            :indeterminate.prop="!allConversationsSelected && conversations.length > 0"
            @change="selectAll($event)"
          />
          <i class="i-lucide-check text-sm" />
        </label>

        <!-- Selected count -->
        <span class="text-sm text-n-slate-11">
          {{ conversations.length }} {{ conversations.length === 1 ? 'selecionado' : 'selecionados' }}
        </span>
      </div>
      <!-- More actions button -->
      <button
        class="flex items-center flex-row rounded-full border p-1.5 select-none cursor-pointer text-sm "
        :class="isModalOpen ? 'border-n-brand dark:border-n-brand bg-n-brand/10 text-n-blue-text' : 'border-n-slate-4 dark:border-n-slate-4 text-n-slate-11 hover:text-n-slate-12 hover:bg-n-alpha-black2/10'"
        @click="$emit('showMoreActions', $event)"
      >
        <span class="ml-1 mr-2">Ações</span>
        <i :class="isModalOpen ? 'i-lucide-chevron-up text-sm' : 'i-lucide-chevron-down text-sm'"/>
      </button>
    </div>
    <div v-if="allConversationsSelected" class="bg-yellow-50 text-yellow-700 rounded-full text-xs mt-2 mb-2 py-1 px-3 border border-solid border-yellow-300 dark:border-yellow-300/10 dark:bg-yellow-200/20 dark:text-yellow-400">
      {{ $t('BULK_ACTION.ALL_CONVERSATIONS_SELECTED_ALERT') }}
    </div>
    <woot-modal
      v-model:show="showCustomTimeSnoozeModal"
      :on-close="hideCustomSnoozeModal"
    >
      <CustomSnoozeModal
        @close="hideCustomSnoozeModal"
        @choose-time="customSnoozeTime"
      />
    </woot-modal>
  </div>
</template>
